import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class NavigationRedirectService {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  private readonly REDIRECTED_FROM_ACTIVITY_KEY = 'redirectedFromActivityDetail';
  private readonly REDIRECTED_TO_GROUP_ID_KEY = 'redirectedToGroupId';

  wasRedirectedFromActivityWithoutPermission(currentGroupId: string): boolean {
    const redirectedFromActivity = sessionStorage.getItem(this.REDIRECTED_FROM_ACTIVITY_KEY);
    const redirectedToGroupId = sessionStorage.getItem(this.REDIRECTED_TO_GROUP_ID_KEY);
    return redirectedFromActivity === 'true' && redirectedToGroupId === currentGroupId;
  }

  async handleBackNavigationFromGroupDetail(replaceUrl = false): Promise<void> {
    this.clearRedirectFlags();
    await this.router.navigate(['/home/explore'], { replaceUrl });
  }

  shouldRedirectToExploreOnBack(): boolean {
    const redirectedFromActivity = sessionStorage.getItem(this.REDIRECTED_FROM_ACTIVITY_KEY);
    const redirectedToGroupId = sessionStorage.getItem(this.REDIRECTED_TO_GROUP_ID_KEY);
    
    if (redirectedFromActivity !== 'true' || !redirectedToGroupId) {
      return false;
    }

    const currentUrl = this.location.path();
    const isOnGroupDetail = currentUrl.startsWith('/home/group/') && currentUrl.includes(redirectedToGroupId);
    return isOnGroupDetail;
  }

  clearRedirectFlags(): void {
    sessionStorage.removeItem(this.REDIRECTED_FROM_ACTIVITY_KEY);
    sessionStorage.removeItem(this.REDIRECTED_TO_GROUP_ID_KEY);
  }
}

